import { useState, useRef, React, useEffect } from 'react';
import styled from 'styled-components';

export default function LessonNoteTextArea(props) {
	const { value, setValue } = props;
  
	const [changed, setChanged] = useState(false);

	const inputRef = useRef();

	useEffect(() => {
    inputRef.current.style.height = 'auto';
		inputRef.current.style.height = inputRef.current.scrollHeight + `px`;
	}, [])

	function handleChange(e) {
    inputRef.current.style.height = 'auto';
    inputRef.current.style.height = inputRef.current.scrollHeight + `px`;

		setValue(e.target.value);
		setChanged(true);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

  function onPress(e) {
  }

 
	return (
    <InputWrapper>
      <Input
        ref={inputRef}
        value={value}
        rows={1}
        placeholder='수업중 특이사항을 입력해주세요'
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyPress={onPress} />
    </InputWrapper>
  )
}

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
  
  padding: 10px;

  width: calc(100% - 20px);
  max-height: 200px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
  background-color: #FFFFFF;
`;

const Input = styled.textarea`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;
  
  resize: none;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;
  border: 0px solid #FFFFFF;

  padding: 0px;
  margin: 0px;

	outline: none;

  background-color: #FFFFFF;

	::placeholder {
    color: #CBCBCB;
	}

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		background-color: #DADADA;
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background-color: #F0F0F0;
		border-radius: 200px;
	}
`;